import { render } from "./PWithdrawalDetails.vue?vue&type=template&id=14e00f7a&scoped=true"
import script from "./PWithdrawalDetails.vue?vue&type=script&lang=js"
export * from "./PWithdrawalDetails.vue?vue&type=script&lang=js"

import "./PWithdrawalDetails.vue?vue&type=style&index=0&id=14e00f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e00f7a"]])

export default __exports__